import { useParams } from 'react-router-dom'
import WaterTruckRequestNewAndEdit from './WaterTruckRequestNewAndEdit'
import WaterTruckRequestDetails from './WaterTruckRequestDetails'
const WaterTruckRequestNew = () => {
  const { id: _id, show } = useParams()
  if (_id && show === 'show') {
    return <WaterTruckRequestDetails />
  }
  return <WaterTruckRequestNewAndEdit />
}

export default WaterTruckRequestNew
